import React from 'react';
import { EXAM_UNIT_PRICE } from 'exam-pricing';
import { LATE_FEE } from 'late-fee';

// Components
import ApplyExamCard from 'components/profile/apply-exams/ApplyExamCard';

// วันตาม tcas-vault timeline/TCAS70.md ↔ enabled.alevel_apply_exams (start / expired / late_payment_expired)
// ช่วงสมัครล่าช้า (ทปอ. 17 ต.ค. 69) = สมัคร/เพิ่มวิชาได้ ค่าสมัครเดิม + 200 บาทต่อการยืนยัน ใช้สิทธิ์ อว. ได้ — src/late-fee.js
const SectionApplyALevel = () => (
  <ApplyExamCard
    examKey='alevel'
    windowKey='alevel_apply_exams'
    title='สมัครสอบ A-Level'
    details={[
      'รับสมัคร 14 - 20 ม.ค. 70',
      `สมัครล่าช้า 21 - 22 ม.ค. 70 (ค่าธรรมเนียมสมัครล่าช้า ${LATE_FEE} บาท ต่อการยืนยันการสมัคร)`,
      `ค่าสมัครวิชาละ ${EXAM_UNIT_PRICE.alevel} บาท`,
    ]}
  />
);

export default SectionApplyALevel;
